import styled, { css } from 'styled-components';

export const PlayOffWrapper = styled.div`
  width: 100%;
`;

export const PlayOffContainer = styled.div`
  ::-webkit-scrollbar {
    display: none;
  }
  ${props => !props.showArrrows && css`
    margin-top: 20px;
  `};
`;

export const TouenamentWrapper = styled.main`
  display:flex;
  flex-direction:row;
  
  ${props => props.theme.mediaQueries.tablet_big_down}{
      .RoundWrapper:first-child .ArrowSeparatorLeft {
        opacity: 0;
        pointer-event: none;
      }
      .RoundWrapper:last-child .ArrowSeparatorRight {
        opacity: 0;
        pointer-event: none;
      }
  }
  ${props => props.hasDetails && String(props.sportId) === '5' && css`
    padding-bottom: 100px;
  `};
  ${props => props.hasDetails && String(props.sportId) === '3' && css`
    padding-bottom: 220px;
  `};
  ${props => props.hasDetails && String(props.sportId) === '2' && css`
    padding-bottom: 100px;
  `};
`;

export const RoundWrapper = styled.ul`
  display:flex;
  flex-direction:column;
  justify-content:center;
  list-style:none;
  padding:0;
  margin-left: 25px;
  &:first-child {
    margin-left:0;
  }
  flex-grow: 1;
  ${props => props.theme.mediaQueries.phone}{
    margin-right: 9.5% !important;
  }
`;

export const ArrowSeparator = styled.div`
  margin: 4px 0px -2px -8px;
  ${props => props.rotation && css`
    transform: rotate(180deg);
    margin: 4px -8px -2px 0px;
  `};
`;

export const HeaderContainer = styled.div`
  width: 100%;
  height: 30px;
  display:flex;
  flex-direction:row;
  margin-bottom:7px;
`;

export const RoundHeader = styled.div`
  background-color: ${props => props.theme.colors.mainColorDark};
  flex: 0 0 215px;
  color: ${props => props.theme.colors.mainFontColor};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    flex: 0 0 100%;
    justify-content: left;
    padding-left: 0px;
    text-transform: uppercase;
  }
  margin: 0px 0px 20px 0px;
  align-items: center;
  justify-content: center;
  height: 30px;
  margin-left: 25px;
  display: flex;
  font-family: ${props => props.theme.fontSets.narrowMedium};
  font-size: 14px;
  &:first-child {
    margin-left:0;
  }
  span {
    padding-left: 10px;
  }
`;

export const Spacer = styled.span`
  flex-grow:1;
  height: 6px;
  :first-child, :last-child{
     flex-grow:.5;
  }
`;

export const GameTop = styled.li`
  padding-top:10px;
  width: 215px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 100%;
  }
  height:40px;
  position: relative;
  border-top:1px solid ${props => (props.isOpen ? props.theme.colors.lightOrange : props.theme.colors.lightGray)};
  border-right:1px solid ${props => (props.isOpen ? props.theme.colors.lightOrange : props.theme.colors.lightGray)};
  border-left:1px solid ${props => (props.isOpen ? props.theme.colors.lightOrange : props.theme.colors.lightGray)};
  ${props => props.isMatchEmpty && css`
    border: 0;
  `};
  overflow: hidden;
`;

export const GameSpacer = styled.li`
  width: 215px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 100%;
  }
  position: relative;
  border-right: 1px solid ${props => props.theme.colors.lightGray};
  border-left: 1px solid ${props => props.theme.colors.lightGray};
  max-height: 2px;
  &.even {
    /* background-color: red; */
  }
  &.odd {
    /* background-color: blue; */
  }

  &.even:not(.round-0)::before, &.odd:not(.round-0)::before {
    position: absolute;
    top: 0;
    left: -9px;
    content: '';
    height: 50px;
    width: 9px;
    border-top: 1px solid ${props => props.theme.colors.lightGray};
    ${props => props.isMatchEmpty && css`
      border: 0;
    `};
    transform: skew(0deg);
  }

  &.even.round-0::after, &.odd.round-0::after {
    height: 50px;
  }
  &.even.round-1::after, &.odd.round-1::after {
    height: 90px;
  }
  &.even.round-2::after, &.odd.round-2::after {
    height: 180px;
  }
  &.even.round-3::after, &.odd.round-3::after {
    height: 355px;
  }

   &.even::after {
     top:0;
    position: absolute;
    right: -18px;
    content: '';
    width: 18px;
    border-top: 1px solid ${props => props.theme.colors.lightGray};
    border-right: 1px solid ${props => props.theme.colors.lightGray};
    transform: skew(0deg);
   }
  &.odd::after {
    bottom:0;
    position: absolute;
    right: -18px;
    content: '';
    width: 18px;
    border-bottom: 1px solid ${props => props.theme.colors.lightGray};
    border-right: 1px solid ${props => props.theme.colors.lightGray};
    transform: skew(0deg);
   }

  &.even.isSecondLast::after, &.odd.isSecondLast::after {
    height: 0;
  }

   &.even.isLast::after, &.odd.isLast::after {
    width: 0;
    height: 0;
  }

`;

export const GameBottom = styled.li`
  padding-bottom:10px;
  width: 215px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 100%;
  }
  height:40px;
  position: relative;
  border-bottom:1px solid ${props => (props.isOpen ? props.theme.colors.lightOrange : props.theme.colors.lightGray)};
  border-right:1px solid ${props => (props.isOpen ? props.theme.colors.lightOrange : props.theme.colors.lightGray)};
  border-left:1px solid ${props => (props.isOpen ? props.theme.colors.lightOrange : props.theme.colors.lightGray)};
  ${props => props.isMatchEmpty && css`
    border: 0;
  `};
  overflow: hidden;
`;

export const LegConatiner = styled.ul`
  margin:0;
  padding:0;
  width:100%;
  list-style: unset;
  display: flex;
  position: relative;
  line-height:29px;
`;


export const TeamLogo = styled.img`
  height:100%;
  object-fit: cover;
  width: 29px;
  flex: 0 1 auto;
  position: relative;
  margin-right:10px;
  margin-left:10px;
`;

export const TeamName = styled.li`
  position: relative;
  font-family: ${props => props.theme.fontSets.narrowRegular};
  font-size: 13px;
  font-weight: ${props => props.weight};
  flex: 1 1 auto;
`;

export const ResultHome = styled.li`
  flex: 0 1 auto;
  position: relative;
  font-family: ${props => props.theme.fontSets.narrowRegular};
  font-size: 13px;
  margin-right:8px;
  font-weight: ${props => props.weight};
`;

export const ResultAway = styled.li`
  flex: 0 1 auto;
  position: relative;
  font-family: ${props => props.theme.fontSets.narrowRegular};
  font-size: 13px;
  margin-right:8px;
  font-weight: ${props => props.weight};
`;

export const MatchLinkWrapper = styled.a`
  color: initial;
  text-decoration: none;
  &.no-event{
    pointer-events: none;
  }
`;

export const VolleyWrapper = styled.div`
  color: initial;
  text-decoration: none;
  position: relative;
  cursor: pointer;
  background-color: ${props => (props.isOpen ? 'rgb(252,225,215)' : 'transparent')};
`;



// WEBPACK FOOTER //
// ./src/components/PlayOffChart/styles.js